import { IntervalLoader } from './ui/IntervalLogo';

/**
 * The console's own full-page wait.
 *
 * Uses the same wordmark and sweeping bar as the SSO interstitial the user
 * has just come from, so the transition between the two systems reads as one
 * continuous step rather than two different products.
 */
export function FullPageSpinner({ label }: { label: string }) {
  return (
    <div className="flex h-full items-center justify-center bg-surface">
      <IntervalLoader label={label} />
    </div>
  );
}
